(function () {
  function viewportWidth(root) {
    var vp = root.querySelector(".am-hero__viewport");
    return vp ? vp.clientWidth : root.clientWidth;
  }

  function syncVideos(root) {
    var slides = root.querySelectorAll(".am-hero__slide");
    slides.forEach(function (slide) {
      var video = slide.querySelector("video");
      if (!video) return;
      if (slide.classList.contains("is-active")) {
        video.muted = true;
        var playPromise = video.play();
        if (playPromise && typeof playPromise.catch === "function") {
          playPromise.catch(function () {});
        }
      } else {
        video.pause();
        try {
          video.currentTime = 0;
        } catch (e) {}
      }
    });
  }

  function go(root, n) {
    var slides = root.querySelectorAll(".am-hero__slide");
    var track = root.querySelector(".am-hero__track");
    var dots = root.querySelectorAll("[data-am-dot]");
    if (!track || !slides.length) return;
    var i = slides.length < 2 ? 0 : (n + slides.length) % slides.length;
    root.dataset.index = String(i);
    if (slides.length > 1) {
      track.style.transform = "translate3d(" + -i * viewportWidth(root) + "px,0,0)";
    }
    slides.forEach(function (slide, idx) {
      slide.classList.toggle("is-active", idx === i);
    });
    dots.forEach(function (dot, idx) {
      dot.classList.toggle("is-active", idx === i);
    });
    syncVideos(root);
  }

  function stop(root) {
    if (root._amTimer) {
      clearInterval(root._amTimer);
      root._amTimer = 0;
    }
  }

  function play(root) {
    var slides = root.querySelectorAll(".am-hero__slide");
    if (slides.length < 2) return;
    var ms = parseInt(root.getAttribute("data-interval"), 10) || 5000;
    stop(root);
    root._amTimer = setInterval(function () {
      go(root, Number(root.dataset.index || 0) + 1);
    }, ms);
  }

  function bind(root) {
    if (root.dataset.amBound === "1") return;
    root.dataset.amBound = "1";
    root.dataset.index = "0";
    go(root, 0);
    play(root);
    root.addEventListener("mouseenter", function () {
      stop(root);
    });
    root.addEventListener("mouseleave", function () {
      play(root);
    });
  }

  function boot() {
    document.querySelectorAll("[data-am-hero]").forEach(bind);
  }

  document.addEventListener("click", function (event) {
    var prev = event.target.closest("[data-am-prev]");
    var next = event.target.closest("[data-am-next]");
    var dot = event.target.closest("[data-am-dot]");
    var control = prev || next || dot;
    if (!control) return;
    var root = control.closest("[data-am-hero]");
    if (!root) return;
    event.preventDefault();
    var i = Number(root.dataset.index || 0);
    if (prev) go(root, i - 1);
    if (next) go(root, i + 1);
    if (dot) {
      var dots = Array.prototype.slice.call(root.querySelectorAll("[data-am-dot]"));
      go(root, dots.indexOf(dot));
    }
    play(root);
  });

  window.addEventListener("resize", function () {
    document.querySelectorAll("[data-am-hero]").forEach(function (root) {
      go(root, Number(root.dataset.index || 0));
    });
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  document.addEventListener("shopify:section:load", boot);
})();
